import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const fetchRoomRecordingsApi = async (roomSid, roomKind) => {
  const response = await api.get(apiRoutes.recordings.listByRoom, {
    // roomKind is additive (E4). Omitted entirely on the legacy path so the
    // request is byte-identical to before when dual-room is off.
    params: roomKind ? { roomSid, roomKind } : { roomSid },
  });
  return response.data;
};

export const getAllRecordings = async () => {
  const response = await api.get(apiRoutes.recordings.all);
  return response.data;
};

export const startRecordingApi = async (sid) => {
  const response = await api.post(apiRoutes.recordings.start(sid));
  return response.data;
};

export const stopRecordingApi = async (sid) => {
  const response = await api.post(apiRoutes.recordings.stop(sid));
  return response.data;
};

export const getRecordingsFromDbApi = async (sid) => {
  const response = await api.get(apiRoutes.recordings.fromDb(sid));
  return response.data;
};

export const downloadRecordingApi = async (sid) => {
  const response = await api.get(apiRoutes.recordings.download(sid), {
    responseType: "blob",
  });
  return response.data;
};
